export default __webpack_public_path__ + "static/media/header-bg-sm.d04d6a5c.png";